import { render, staticRenderFns } from "./CheckboxTagDropdown.vue?vue&type=template&id=cfca3d84&scoped=true&"
import script from "./CheckboxTagDropdown.vue?vue&type=script&lang=js&"
export * from "./CheckboxTagDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxTagDropdown.vue?vue&type=style&index=0&id=cfca3d84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfca3d84",
  null
  
)

export default component.exports